import React, { FC } from "react"
import { ListboxButton, ListboxOption } from "@headlessui/react"

import { PhaseContext } from "../../../utils/Interfaces"
import { ListBox } from "../../../lib/fragments/ListBox"
import { InputBasic } from "../../../components/utils/InputBasic"

export const IdentityPhase: FC<PhaseContext> = ({ phase, state, values, faults, listboxHandler, blurHandler, changeHandler }) => {
    return (
        <React.Fragment>
            <div className="w-full pb-8 text-base font-semibold text-stone-700 dark:text-slate-300 uppercase tracking-wide">
                {phase.title}

                <p className="text-stone-500 dark:text-stone-300 pt-1 text-sm normal-case tracking-normal font-normal">
                    {phase.caption}
                </p>
            </div>

            <div className="w-full pb-8 md:max-w-md">
                <ListBox
                    value={values.auth.e}
                    eventHandler={(e: any) => listboxHandler(e, 'auth', phase)}
                    label={
                        <>
                            <p className="text-sm font-semibold text-stone-600 dark:text-slate-300 uppercase tracking-wide">
                                1. Authentication Method
                            </p>

                            <p className="w-full text-stone-500 dark:text-slate-400 pb-1 text-sm">
                                Select how the user will sign in.
                            </p>
                        </>
                    }
                    button={
                        <ListboxButton className="relative w-full bg-white border border-slate-200 rounded-md py-2.5 pl-1 pr-3 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-orange-500 focus:border-orange-500 sm:text-sm">
                            <span className="flex w-full items-center align-middle">
                                <div className="flex-grow flex items-center">
                                    <span className="ml-3 block truncate">{values.auth.e}</span>
                                </div>

                                <span className="fa-light fa-chevron-down float-end"></span>
                            </span>

                        </ListboxButton>
                    }
                    options={
                        state.data.providers.map((provider: any) => {
                            if (!provider.n) return

                            return (
                                <ListboxOption key={`prvdr-${provider.g}`} value={provider} className="group relative cursor-default select-none py-2 pl-3 pr-9 data-[selected]:text-orange-600 data-[focus]:bg-orange-100 dark:data-[focus]:bg-orange-900/70 data-[focus]:text-orange-700 dark:data-[focus]:text-orange-500 rounded-md w-full">
                                    <div className="flex items-center gap-x-4">
                                        <span className="truncate group-data-[selected]:font-medium">
                                            {provider.e}
                                        </span>
                                    </div>

                                    <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-orange-600 group-[&:not([data-selected])]:hidden">
                                        <span className="fa-light fa-check"></span>
                                    </span>
                                </ListboxOption>
                            )
                        })
                    }
                />
            </div>

            <div className="w-full pb-4 text-sm">
                <p className="text-sm font-semibold text-stone-600 dark:text-slate-300 uppercase tracking-wide">
                    2. User Identity
                </p>

                <p className="w-full text-stone-500 dark:text-slate-400 pb-4 text-sm">
                    Basic profile details for this account.
                </p>

                <div className="w-full flex gap-x-4 flex-col md:flex-row gap-y-4 pb-6">
                    <div className="w-full md:flex-1">
                        <InputBasic
                            required={true}
                            name={"first_name"}
                            posting={state.posting}
                            label={"First Name"}
                            blurHandler={(e: any) => blurHandler(e, phase)}
                            changeHandler={changeHandler}
                            value={values.first_name}
                            error={faults.first_name}
                        />
                    </div>

                    <div className="w-full md:flex-1">
                        <InputBasic
                            required={true}
                            name={"last_name"}
                            posting={state.posting}
                            label={"Last Name"}
                            blurHandler={(e: any) => blurHandler(e, phase)}
                            changeHandler={changeHandler}
                            value={values.last_name}
                            error={faults.last_name}
                        />
                    </div>
                </div>

                <div className="w-full pb-8 md:max-w-md">
                    <InputBasic
                        name={"email"}
                        required={true}
                        label={"Primary Email"}
                        posting={state.posting}
                        value={values.email}
                        error={faults.email}
                        placeHolder={"user@domain.com"}
                        blurHandler={(e: any) => blurHandler(e, phase)}
                        changeHandler={changeHandler}
                    />
                </div>
            </div>
        </React.Fragment>
    )
}